export type TColors = 'red' | 'blue' | 'gray';

export enum ELabelType {
  OpenVillage = 'openVillage',
  Reliable = 'reliable',
  Escrow = 'escrow',
}

export interface ILabelsProps {
  key: ELabelType;
  text: string;
  color: TColors;
  icon?: React.ReactElement;
  tooltipContent?: React.ReactNode;
  tooltipTitle?: string;
}
